<template>
    <div :class="unitBadgeWrapperMergedClasses">
        <div :class="unitBadgeClasses" v-for="(unit, index) in units" :key="unit" :style="`z-index: ${10 - index}`">
            <Icon :type="unit" :filled="false" class="text-[inherit]" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { Icon } from '../icons'
    import { computed } from 'vue'
    import { twMerge } from 'tailwind-merge'
    import { UnitType } from '../../types/units.js'

    const props = withDefaults(
        defineProps<{
            class?: any
            size?: 'sm' | 'md' | 'lg'
            units: (UnitType | 'label')[]
            variant?: 'neutral' | 'light' | 'dark' | 'outline'
        }>(),
        {
            size: 'md',
            variant: 'light'
        }
    )

    const unitBadgeClasses = computed(() => {
        const baseClasses = 'relative aspect-square border flex items-center justify-center rounded-full'
        const sizeClasses = {
            sm: 'w-8 p-1 [&:nth-child(n+2)]:ml-[-6px] [&:nth-child(n+2)]:[clip-path:inset(0_0_0_3px)]',
            md: 'w-10 p-2 [&:nth-child(n+2)]:ml-[-8px] [&:nth-child(n+2)]:[clip-path:inset(0_0_0_4px)]',
            lg: 'w-12 p-2 [&:nth-child(n+2)]:ml-[-10px] [&:nth-child(n+2)]:[clip-path:inset(0_0_0_5px)]'
        }
        const variantClasses = {
            neutral: 'bg-surface-background  border-surface-border',
            light: 'bg-system-light border-surface-border',
            dark: 'bg-system-dark  border-surface-border',
            outline: 'border-surface-border'
        }
        return `${baseClasses} ${sizeClasses[props.size]} ${variantClasses[props.variant]}`
    })

    const unitBadgeWrapperBaseClasses = computed(() => {
        const variantClasses = {
            neutral: 'text-default',
            light: 'text-default',
            dark: 'text-system-light',
            outline: 'text-default'
        }
        return ['flex flex-row z-0 transition-colors duration-200', variantClasses[props.variant]]
    })

    // Allow overriding base classes
    const unitBadgeWrapperMergedClasses = computed(() => twMerge(unitBadgeWrapperBaseClasses.value, props.class))
</script>
